import './question.scss';
import _ from "lodash";
import info from "../../../assets/images/AMO_Icons/dejaClient.svg";
import {getTranslation} from "../../../utils/index.js";

export const Question = (props) => {
    const {icon, title, subtitle, position, children, loader, full, bandeau, dejaClient, headingLevel = 2, asFieldset = false, titleId, required = false } = props
    const HeadingTag = `h${headingLevel}`;
    // RGAA 11.10 : mention "(obligatoire)" pour les lecteurs d'écran, reprise dans la legend
    // et dans le titre (donc dans le nom accessible des champs reliés au titre par aria-labelledby)
    const requiredMention = required ? '<span class="visually-hidden"> (obligatoire)</span>' : '';
    // RGAA 11.9 : la legend reprend la phrase entière dans l'ordre affiché — le sous-titre
    // (p.text-secondary) précède visuellement le titre sauf en position "top"
    const legendText = subtitle ? (position === 'top' ? `${title} ${subtitle}` : `${subtitle} ${title}`) : title;
    const legendHtml = `${legendText}${required ? ' (obligatoire)' : ''}`;

    return (
        <div className={`${!loader && 'question'} rounded text-center ${full ? 'col-lg-10 offset-lg-1' : 'col-lg-8 offset-lg-2'} col-md-12`}>

            {
                bandeau && props.apporteur1.codeBelair === 43397 &&
                (
                    Boolean(dejaClient) && _.get(props.data, `DemandeTarif[ListePersonnes][0][Prenom]`) && _.get(props.data, `DemandeTarif[ListePersonnes][0][Nom]`)
                        ? (
                            <div className={'row rounded-5 border border-primary-light'}>
                                <div className={'d-lg-flex align-items-center gap-4 p-3'}>
                                    <img src={info} alt="" aria-hidden="true"/>
                                    <div className={'text-start ms-4'}>
                                        <p className={'f-16 fw-bold mb-2'} dangerouslySetInnerHTML={{__html: getTranslation("alreadyCustomer.welcome", {firstName: _.get(props.data, `DemandeTarif[ListePersonnes][0][Prenom]`), lastName: _.get(props.data, `DemandeTarif[ListePersonnes][0][Nom]`)})}} />
                                        <p className={'f-13'}>{getTranslation("alreadyCustomer.thankyou")}</p>
                                    </div>
                                </div>
                            </div>
                        )
                        : (
                            !_.get(props.data, `DemandeTarif[ListePersonnes][0][Nom]`) && !_.get(props.data, `DemandeTarif[ListePersonnes][1][Nom]`) &&
                            <div className={'row rounded-5 border border-primary-light'}>
                                <div className={'d-lg-flex align-items-center gap-4 p-3'}>
                                    <img src={info} alt="" aria-hidden="true"/>
                                    <div className={'text-start ms-4'}>
                                        <p className={'f-16 fw-bold mb-2'}>{getTranslation("alreadyCustomer.alreadyTitle")}</p>
                                        <p className={'f-13'}>{getTranslation("alreadyCustomer.connexion")}</p>
                                    </div>
                                    <a href={'https://mon-espace.april-moto.com/'} target="_blank" rel="noopener noreferrer" className={'btn btn-primary btn-smaller'}>{getTranslation("alreadyCustomer.cta")}<span className="visually-hidden"> (nouvelle fenêtre)</span></a>
                                </div>
                            </div>
                        )
                )
            }


            <div className={'p-3'}>
                {icon && <img src={icon} alt="" aria-hidden="true" className={'mx-2'} width={65} />}
                <div className="row">
                    <div className="col-12 col-lg-8 offset-lg-2">
                        <div className={`${position === 'top' ? 'flex-column' : 'flex-column-reverse'} d-flex`}>
                            <HeadingTag id={titleId} className={'question-title mx-2'} data-title={title.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/gi, ' ')} dangerouslySetInnerHTML={{ __html: title + requiredMention }} />
                            <p className={'f-16 text-secondary mx-2 fw-bolder'}>{subtitle}</p>
                        </div>
                    </div>
                </div>
                {asFieldset ? (
                    <fieldset className="fieldset-unstyled">
                        <legend className="visually-hidden" dangerouslySetInnerHTML={{__html: legendHtml}} />
                        {children}
                    </fieldset>
                ) : (
                    children
                )}
            </div>
        </div>
    );
};

Question.defaultProps = {
    children: <p>Children Question</p>,
};
